import React from 'react';
import './Nosotros.css';
import background from '../assets/background.jpg';

const Nosotros = () => {
  const heroStyle = {
    backgroundImage: `url(${background})`,
  };

  return (
    <div id="nosotros">
      <div className="hero" style={heroStyle}>
        <div className="cards-container">
          <div className="info-card">
            <h3>Quiénes Somos</h3>
            <p>
              Somos un centro de formación técnica, desarrollo de materiales profesionales
              y consultoría especializada enfocado en ingeniería, automatización, energía
              e innovación tecnológica. Diseñamos cursos con constancia DC-3, materiales
              claros y utilizables, y soluciones prácticas para empresas, instituciones
              y gobiernos.
            </p>
          </div>

          <div className="info-card">
            <h3>Nuestra Misión</h3>
            <p>
              Brindar capacitación accesible y consultoría técnica que traduzcan el
              conocimiento especializado en resultados reales para nuestros clientes,
              mediante programas estructurados, materiales de calidad y acompañamiento
              cercano.
            </p>
          </div>

          <div className="info-card">
            <h3>Nuestra Visión</h3>
            <p>
              Ser una referencia en formación técnica y consultoría en innovación en
              México y Latinoamérica, reconocidos por la calidad de nuestros cursos,
              la solidez de nuestros materiales y el impacto de nuestros proyectos.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Nosotros;




